export default __webpack_public_path__ + "static/aeroFIX-6354c7d314a6f0aafd58db39ce7f7455.jpg";